import { SvgWrapper } from 'components/svgs/SvgWrapper/SvgWrapper';

export const AltaWearSvg = ({ ...svgProps }) => (
  <SvgWrapper
    data-testid="native-app-wear-icon"
    width="36"
    height="36"
    fill="var(--colorPrimary)"
    viewBox="10 10 36 36"
    {...svgProps}
  >
    <path
      opacity="0.6"
      d="M35.6094 10.1754C36.2458 10.1755 36.8567 10.4095 37.3281 10.8278L37.5215 11.0182L40.6406 14.4313C41.0394 14.8676 41.2738 15.4258 41.3115 16.0123H41.3193V39.9869H41.3115C41.2739 40.5738 41.0396 41.1325 40.6406 41.569L37.5215 44.9821C37.0308 45.5189 36.3366 45.8248 35.6094 45.8248H20.3906C19.6633 45.8248 18.9692 45.5189 18.4785 44.9821L15.3594 41.569C14.9604 41.1325 14.7261 40.5738 14.6885 39.9869H14.6807V16.0123H14.6885C14.7262 15.4258 14.9606 14.8676 15.3594 14.4313L18.4785 11.0182C18.9692 10.4813 19.6633 10.1754 20.3906 10.1754H35.6094ZM17.6807 16.3365V39.6617L20.5723 42.8248H35.4277L38.3193 39.6608V16.3375L35.4287 13.1754H20.5713L17.6807 16.3365Z"
    />
    <circle
      cx="28.0001"
      cy="22.814"
      r="4.55768"
      fill="none"
      stroke="var(--colorPrimary)"
      strokeWidth="4"
    />
    <path d="M22.54 34.2671C22.54 33.1625 23.4355 32.2671 24.54 32.2671H31.4602C32.5648 32.2671 33.4602 33.1625 33.4602 34.2671V36.8668C33.4602 37.4066 33.242 37.9236 32.8551 38.3001L32.2497 38.8892C31.8763 39.2526 31.3758 39.4559 30.8548 39.4559H25.1454C24.6244 39.4559 24.124 39.2526 23.7506 38.8892L23.1452 38.3001C22.7583 37.9236 22.54 37.4066 22.54 36.8668V34.2671Z" />
  </SvgWrapper>
);
